import { isOverlapAssets, isTimelineItemsIntersected } from '~/Util/RangeTools'

const getExternalSourceAssetsStartTime = draggableAssets => {
  let startTime = 0
  return draggableAssets.reduce((result, file, index) => {
    const sum = { ...result }
    sum[index] = {
      startTime,
      duration: file.duration,
      endTime: startTime + file.duration,
    }
    startTime += file.duration
    return sum
  }, {})
}

export const getIntersectionData = ({
  staticAssets,
  draggableAssets,
  layers,
  shiftingDragAssets,
  offsetLayerIndex,
  isExternalSource,
  draggableBlockDuration,
  clientMousePosition,
  dragItem,
}) => {
  const dragFigureStart = isExternalSource ? 0 : draggableAssets[0]?.startTime
  const dragFigureEnd = isExternalSource
    ? draggableBlockDuration
    : draggableAssets.at(-1)?.endTime ?? 0
  const sourceFileStartTimes = isExternalSource
    ? getExternalSourceAssetsStartTime(draggableAssets)
    : {}

  // If first draggable asset startTime less then 0, define offset shifting to zero
  const start = isExternalSource ? sourceFileStartTimes[0].startTime : draggableAssets[0]?.startTime
  const negativeOffset = start + shiftingDragAssets < 0 ? (start + shiftingDragAssets) * -1 : 0

  return staticAssets.reduce((sum, staticAsset) => {
    let result = { ...sum }
    draggableAssets.forEach((dAsset, index) => {
      // OffsetLayerIndex - moving the dragged block up or down
      const dragItemLayerId = isExternalSource
        ? layers[offsetLayerIndex]?.id
        : layers[dAsset.layerIndex + offsetLayerIndex]?.id

      const isMouseOver = (staticAsset.startTime <= clientMousePosition
        && clientMousePosition <= staticAsset.endTime
        && staticAsset.layerId === layers[(dragItem.layerIndex ?? 0) + offsetLayerIndex]?.id)

      const dragItemStartTime = isExternalSource
        ? sourceFileStartTimes[index].startTime + shiftingDragAssets + negativeOffset
        : dAsset.startTime + shiftingDragAssets + negativeOffset
      const dragItemEndTime = dragItemStartTime + (
        isExternalSource ? sourceFileStartTimes[index].duration : dAsset.duration
      )

      const isIntersected = (isTimelineItemsIntersected(
        staticAsset.startTime, staticAsset.endTime, dragItemStartTime, dragItemEndTime
      ) && (dragItemLayerId === staticAsset.layerId))

      const isOverlapped = isOverlapAssets(
        staticAsset.startTime, staticAsset.endTime, dragItemStartTime, dragItemEndTime
      ) && (dragItemLayerId === staticAsset.layerId)

      const dragFirstItemStartTime = dragFigureStart + shiftingDragAssets + negativeOffset
      const dragLastItemEndTime = dragFigureEnd + shiftingDragAssets + negativeOffset

      // The dragged block may have jagged edges.
      // The distance between the start of the dragged block and the start of the current dragged element in the block
      const dragFirstMinusCurrentStartTime = isExternalSource
        ? 0
        : dragFirstItemStartTime - dragItemStartTime
      // The distance between the end of the dragged block and the end of the current dragged element in the block
      const dragEndMinusCurrentEndTime = isExternalSource
        ? 0
        : dragLastItemEndTime - dragItemEndTime

      const data = {
        staticAsset,
        draggableAsset: dAsset,
        staticEndTime: staticAsset.endTime,
        staticStartTime: staticAsset.startTime,
        staticDuration: staticAsset.duration,
        dragItemStartTime,
        dragItemEndTime,
        dragFirstItemStartTime,
        dragLastItemEndTime,
        draggableBlockDuration,
        shiftingDragAssets,
        dragFirstMinusCurrentStartTime,
        dragEndMinusCurrentEndTime,
        dragFigureEnd,
        dragFigureStart,
      }

      const isStopMoveAssets = isIntersected && !result.isIntersected

      if (isStopMoveAssets) {
        result = {
          ...result,
          isIntersected,
          intersectedData: { ...data },
        }
      }

      if (isOverlapped && !result.isOverlapped) {
        result = {
          ...result,
          isOverlapped,
          overlappedData: { ...data },
        }
      }

      if (isMouseOver) {
        result = {
          ...result,
          isMouseOver,
        }
      }
    })
    return result
  }, {
    isOverlapped: false,
    isIntersected: false,
    intersectedData: null,
    overlappedData: null,
    isMouseOver: false,
  })
}
